import React, { useMemo } from "react";
import { NavLink } from "react-router";
import { getBrowser, getDevice } from "./utils/deviceDetector";
import { useAuth } from "./AuthContext";
import image1 from "./assets/image1.jpg";
import image2 from "./assets/image2.jpg";
import image3 from "./assets/image3.jpg";
import "./home.css";

const Home = () => {
  const currentYear = new Date().getFullYear();

  const deviceType = useMemo(() => getDevice(), []);
  const deviceBrowser = useMemo(() => getBrowser(), []);

  const { user } = useAuth();

  return (
    <div className="body-container">
      {/* Mission Statement or Description Box */}
      <div
        style={{ marginTop: user ? "40px" : null }}
        className="mission-statement"
      >
        <p>
          Alpha Phi Alpha Fraternity, Incorporated is among the oldest and most
          loyal investors in higher education in the United States.{" "}
          <span style={{ fontFamily: "gotham-medium", color: "#333" }}>
            The fraternity began as a study group of Black men who defied racial
            segregation at Cornell University in 1906.
          </span>{" "}
          Its concepts for community advancement and inclusion in higher
          education have created 706 chapters throughout the U.S., Africa, West
          Indies, Europe, Asia, and the Virgin Islands. The Fraternity has been
          interracial since 1945, and over 200,000 Brothers have bonded to
          advance its ideas and precepts.
        </p>
      </div>
      {/* Image Section */}
      <div className="image-section">
        <div className="image-card">
          <img
            src={image1}
            alt="Alpha Phi Alpha Rho Chapter"
            className="image-content"
          />
        </div>
        <div className="image-card">
          <img
            src={image2}
            alt="Alpha Phi Alpha Rho Chapter"
            className="image-content"
          />
        </div>
        <div className="image-card">
          <img
            src={image3}
            alt="Alpha Phi Alpha Rho Chapter"
            className="image-content"
          />
        </div>
      </div>
      {/* scholarship info */}
      <div className="scholarship-info">
        <h2 style={{ color: "white" }}>
          {currentYear} O. Wilson <br className="force-break" /> Winters
          Memorial <br />
          Scholarship Program
        </h2>

        <p>
          In alignment with the fraternity's aim of{" "}
          <span style={{ fontFamily: "gotham-medium" }}>
            "manly deeds, scholarship, and love for all mankind",
          </span>{" "}
          the Rho Chapter of Alpha Phi Alpha Fraternity, Inc. is proud to
          announce its {currentYear} O. Wilson Winters Memorial Scholarship
          Program. Geared toward African American men, the Rho Chapter
          Scholarship Program seeks applicants from the greater Philadelphia
          region who will be matriculating at an institution of higher education
          in the Fall {currentYear} term and whose aspirations align with the
          fraternity's aims.
        </p>
      </div>
      {/* scholarship application btn */}
      <NavLink
        to="/scholarship-requirements"
        className="primary-btn"
        style={{
          paddingTop: deviceType === "iOS" ? "25px" : "auto",
          height: deviceType === "iOS" ? "10px" : "auto",
        }}
      >
        {currentYear} SCHOLARSHIP APPLICATION
      </NavLink>

      {/* Book Awards Section */}
      <div className="book-awards-section">
        <h2>
          {currentYear} Paul Frost and <br className="force-break" />
          Norrece T. Jones <br className="force-break-2" />
          Book Awards
        </h2>
        <p className="book-awards-intro">
          The Rho Chapter is proud to present annual book awards recognizing
          academic excellence and mentorship in our community.
        </p>
        <div className="awards-list">
          <div className="award-item">
            <h3>Brother Paul Frost Award</h3>
            <p>Elementary and Middle School Students (Grades K-8)</p>
          </div>
          <div className="award-item">
            <h3>Brother Norrece T. Jones Award</h3>
            <p>High School Students (Grades 9-12)</p>
          </div>
        </div>
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSfd7EYoCuUpVIzbvv1oDhoWxZEDtQXlT-XcXBm_9VHKDo5TUA/viewform"
          target="_blank"
          rel="noopener noreferrer"
          className="book-award-btn"
          style={{
            paddingTop: deviceType === "iOS" ? "25px" : "auto",
            height: deviceType === "iOS" ? "10px" : "auto",
          }}
        >
          APPLY FOR BOOK AWARD
        </a>
      </div>

      {deviceBrowser === "Safari" && (
        <p
          style={{
            color: "#333",
            fontSize: "8.5px",
            marginTop: "25px",
            fontFamily: "gotham-light",
          }}
        >
          For a better experience, please use Chrome instead of Safari.
        </p>
      )}
    </div>
  );
};

export default Home;
